// app.routes.ts
import { Routes } from '@angular/router';
import { authGuard, guestGuard } from './guard/auth.guard';

export const routes: Routes = [
  {
    path: 'register',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    data: { title: 'Registrar' },
  },
  {
    path: 'login',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
    data: { title: 'Login' },
  },
  {
    path: 'home',
    canMatch: [authGuard],
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
    data: { title: 'Home' },
  },
  {
    path: 'forgot-password',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
    data: { title: 'Forgot Password' },
  },
  {
    path: 'migrate-account',
    canMatch: [guestGuard],
    loadComponent: () =>
      import('./pages/migrate-account/migrate-account.component').then(
        (m) => m.MigrateAccountComponent
      ),
    data: { title: 'Migrate Account' },
  },
  { path: '**', redirectTo: '/login' },
];
